export default "/_next/static/chunks/fonts/GoudyOldStyle-Bold-a63d63ef62c894a35dc591f496864811.ttf";